import Axios from '../services/Axios';
import axios from 'axios';

export default {
    install: (app) => {
        new Axios(); // customise the axios instance...
        app.provide('$http', axios);
    }
}
